import { render, staticRenderFns } from "./database.vue?vue&type=template&id=7501c839&scoped=true"
import script from "./database.vue?vue&type=script&lang=js"
export * from "./database.vue?vue&type=script&lang=js"
import style0 from "./database.vue?vue&type=style&index=0&id=7501c839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7501c839",
  null
  
)

export default component.exports